import { Injectable } from "@angular/core";
import { AnnotationConstraints, ConnectorModel, NodeModel, TextModel } from "@syncfusion/ej2-angular-diagrams";

@Injectable({
  providedIn: "root",
})
export class SharedHTMLSettingsDataService {
  public ToasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: "ease-out",
    progressBar: true,
    positionClass: "toast-top-right",
    tapToDismiss: true,
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "slideUp",
  };
  public PhoneNumberMask: String = '(000)000-0000';
  
  public nodeDynamic: NodeModel = {
    shape: {
      type:'Text',
    } as TextModel,
    offsetX: 250,
    offsetY: 250,
    width: 100,
    height: 30,
    visible: true,
    style: {fill: 'none', textAlign: 'Left'},
    annotations: [{
        content: '',
        constraints: AnnotationConstraints.ReadOnly,
        
    }]
  };
  public connectorDynamic: ConnectorModel = {
    id: 'd1',
    segments: [
          {
            type: "Straight"
          }],
    sourcePoint: {x: 100, y: 100},
    targetPoint: {x: 350, y: 100},
    targetDecorator: { shape: 'None' },
    annotations: [{
      content: '',
      style: {
            textAlign: 'Left',
          },
      alignment: 'Before',
      displacement: {x: 0, y: 20},
      constraints: AnnotationConstraints.ReadOnly
    }]
  };

  getFontSize() {
    let fontSizeList = [];
    for (let i = 1; i <= 12; i++) {
      fontSizeList.push(i);
    }
    for (let i = 14; i <= 48; i += 2) {
      fontSizeList.push(i);
    }
    return JSON.parse(JSON.stringify(fontSizeList));
  }

  closeModalById(modalId: string) {
    const modalEl = document.getElementById(modalId);
    if (modalEl) {
    const modalInstance = window['bootstrap'].Modal.getInstance(modalEl);
        if (modalInstance) {
            modalInstance.hide();
        }
    }
    document.body.classList.remove('modal-open');
    if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
    }
  }

  openModalById(modalId: string) {
    const modalEl = document.getElementById(modalId);
    if (modalEl) {
      let modal = window['bootstrap'].Modal.getInstance(modalEl);
      if (!modal) {
        modal = new window['bootstrap'].Modal(modalEl, { backdrop: 'static', keyboard: false });
      }
      modal.show();
    }
  }

}
